import { render, staticRenderFns } from "./DialogDetails.vue?vue&type=template&id=e5e135e2"
import script from "./DialogDetails.vue?vue&type=script&lang=js"
export * from "./DialogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports